// Module
var code = "<div class=\"description-container\"> <div class=\"container\"> <div class=\"column\"> <p render-html-data template=\"{{ vm.iconComponent }}\"></p> </div> <div class=\"column\"> <div render-html-data template=\"{{ vm.description }}\"></div> </div> </div> </div> ";
// Exports
module.exports = code;